import { styled } from '@mui/material/styles';
import { Box, Typography, Button, TextField, Modal, Switch } from '@mui/material';

// ============================================
// Modal
// ============================================
export const StyledModal = styled(Modal)({});

export const ModalContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '1060px',
  backgroundColor: '#fff',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

// ============================================
// Header
// ============================================
export const ModalHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '56px',
  padding: '0 32px',
  backgroundColor: '#262626',
  flexShrink: 0,
});

export const ModalTitle = styled(Typography)({
  fontSize: '20px',
  fontWeight: 600,
  color: '#fff',
});

export const CloseIconButton = styled(Box)({
  width: '32px',
  height: '32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  color: '#fff',
  '&:hover': {
    opacity: 0.7,
  },
});

// ============================================
// Content
// ============================================
export const ModalContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  alignItems: 'center',
  padding: '24px 32px 32px',
});

export const ContentRow = styled(Box)({
  display: 'flex',
  gap: '32px',
  alignItems: 'flex-start',
  justifyContent: 'center',
});

// ============================================
// Left Section - Template Settings
// ============================================
export const SettingsSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '516px',
});

export const AutoSendRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

export const AutoSendLabel = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
});

export const CustomSwitch = styled(Switch)({
  width: 40,
  height: 20,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#4ab3bc',
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 16,
    height: 16,
  },
  '& .MuiSwitch-track': {
    borderRadius: 10,
    backgroundColor: '#d9d9d9',
    opacity: 1,
  },
});

// ============================================
// Form Fields
// ============================================
export const FieldGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
});

export const FieldLabel = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
});

export const FieldTitleRow = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '100%',
});

export const StyledInput = styled(TextField)({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    height: '48px',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 500,
    '& fieldset': {
      borderColor: '#d9d9d9',
    },
    '&:hover fieldset': {
      borderColor: '#a6a6a6',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#4ab3bc',
    },
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#a6a6a6',
    opacity: 1,
  },
});

export const StyledTextArea = styled(TextField)({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 500,
    alignItems: 'flex-start',
    '& fieldset': {
      borderColor: '#d9d9d9',
    },
    '&:hover fieldset': {
      borderColor: '#a6a6a6',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#4ab3bc',
    },
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#a6a6a6',
    opacity: 1,
  },
});

export const ByteCountText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
  textAlign: 'right',
  width: '100%',
});

// ============================================
// Ad Checkbox
// ============================================
export const AdCheckRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

// ============================================
// Variable Data
// ============================================
export const DataLabelRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

export const HelpIcon = styled(Box)({
  width: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#a6a6a6',
  cursor: 'pointer',
});

export const VariableDataBox = styled(Box)({
  display: 'flex',
  gap: '16px',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  padding: '16px',
  border: '1px solid #d9d9d9',
  borderRadius: '8px',
  backgroundColor: '#fff',
});

export const VariableTag = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#4ab3bc',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  '&:hover': {
    opacity: 0.7,
  },
});

// ============================================
// Right Section - Preview
// ============================================
export const PreviewSection = styled(Box)({
  width: '369px',
  backgroundColor: '#f2f2f2',
  borderRadius: '20px',
  padding: '16px 24px 24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  flexShrink: 0,
  alignSelf: 'stretch',
});

export const PreviewTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#262626',
});

export const PreviewContent = styled(Box)({
  flex: 1,
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '10px',
  overflowY: 'auto',
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
});

export const PreviewPlaceholder = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#a6a6a6',
});

// ============================================
// Footer
// ============================================
export const ModalFooter = styled(Box)({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  justifyContent: 'center',
});

export const DeleteButton = styled(Button)({
  width: '120px',
  height: '48px',
  backgroundColor: '#fff',
  border: '1px solid #F44336',
  borderRadius: '8px',
  fontSize: '20px',
  fontWeight: 600,
  color: '#F44336',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#FFF5F5',
  },
});

export const CancelButton = styled(Button)({
  width: '120px',
  height: '48px',
  backgroundColor: '#d9d9d9',
  borderRadius: '8px',
  fontSize: '20px',
  fontWeight: 600,
  color: '#262626',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#c9c9c9',
  },
});

export const SaveButton = styled(Button)({
  width: '240px',
  height: '48px',
  backgroundColor: '#4ab3bc',
  borderRadius: '8px',
  fontSize: '20px',
  fontWeight: 600,
  color: '#fff',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#3da3ab',
  },
});
